import React from 'react';
import { motion } from 'framer-motion';
import { DoorOpenIcon, LanguagesIcon, ShieldCheckIcon, HeartPulseIcon, SmartphoneIcon, ClipboardCheckIcon, BoxIcon } from 'lucide-react';
interface Tomo {
  num: string;
  title: string;
  desc: string;
  Icon: BoxIcon;
}
export function Content() {
  const tomos: Tomo[] = [{
    num: 'T1',
    title: 'El primer minuto que define todo',
    desc: 'Cómo recibir al propietario y generar confianza antes de abrir la ficha clínica.',
    Icon: DoorOpenIcon
  }, {
    num: 'T2',
    title: 'Explicar sin que te miren con cara de "no entiendo nada"',
    desc: 'Técnicas para traducir diagnósticos complejos en palabras que el dueño entiende y retiene.',
    Icon: LanguagesIcon
  }, {
    num: 'T3',
    title: 'Cuando dicen "en otra clínica me cobran menos"',
    desc: 'Guiones probados para defender el valor de tu trabajo sin ponerte a la defensiva ni bajar el precio.',
    Icon: ShieldCheckIcon
  }, {
    num: 'T4',
    title: 'Dar malas noticias sin que la consulta se derrumbe',
    desc: 'Protocolo paso a paso para diagnósticos graves, pronósticos reservados y eutanasia.',
    Icon: HeartPulseIcon
  }, {
    num: 'T5',
    title: 'El propietario que sabe más que vos (según él)',
    desc: 'Cómo manejar al dueño que llega con el diagnóstico de YouTube, TikTok o el grupo de WhatsApp.',
    Icon: SmartphoneIcon
  }, {
    num: 'T6',
    title: 'Cerrar la consulta para que el tratamiento se cumpla',
    desc: 'Técnicas de cierre que aseguran adherencia y eliminan las llamadas innecesarias.',
    Icon: ClipboardCheckIcon
  }];
  return <section className="bg-cream py-10 sm:py-20 px-5" data-id="element-48">
      <div className="max-w-6xl mx-auto" data-id="element-49">
        <div className="text-center text-[10px] sm:text-xs font-semibold tracking-[0.14em] uppercase text-green mb-2 sm:mb-3" data-id="element-50">
          Contenido completo
        </div>
        <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold text-center text-navy mb-2 sm:mb-3 leading-tight" data-id="element-51">
          Los 6 Tomos de La Consulta Perfecta — Pro
        </h2>
        <p className="text-center text-gray text-sm sm:text-lg mb-8 sm:mb-12" data-id="element-52">
          Tu hoja de ruta para cada conversación difícil
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-5 mb-10 sm:mb-16" data-id="element-53">
          {tomos.map((tomo, i) => {
          const {
            Icon
          } = tomo;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06,
            duration: 0.35
          }} whileHover={{
            y: -4,
            boxShadow: '0 8px 28px rgba(0,0,0,0.12)'
          }} whileTap={{
            scale: 0.98
          }} className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-5 shadow-sm hover:shadow-md transition-shadow cursor-default flex flex-col" data-id="element-54">
                <div className="flex items-center gap-2.5 mb-2.5 sm:mb-3" data-id="element-55">
                  <div className="bg-gradient-to-br from-navy to-navy-mid w-9 h-9 sm:w-11 sm:h-11 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-56">
                    <Icon className="w-4.5 h-4.5 sm:w-5 sm:h-5 text-gold-light" strokeWidth={2} data-id="element-57" />
                  </div>
                  <span className="bg-gold text-navy font-bold text-[10px] sm:text-xs px-2 py-0.5 rounded-md" data-id="element-58">
                    {tomo.num}
                  </span>
                </div>
                <h3 className="text-xs sm:text-sm font-bold text-navy leading-snug mb-1.5" data-id="element-59">
                  {tomo.title}
                </h3>
                <p className="text-[10px] sm:text-xs text-gray-600 leading-relaxed" data-id="element-60">
                  {tomo.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}